import React from "react";
import styled from "styled-components";
import * as Icon from "react-feather";

import { P } from "../Texts";

const ScheduleCardStyle = styled.div`
  background: ${(props) => (props.isSelected ? "#f5f4fa" : "#ffffff")};
  border-radius: 8px;

  :hover {
    background: ${(props) => (props.isSelected ? "#f5f4fa" : "#f7fafc")};
  }
`;

export const CaseScheduleCard = ({
  _case,
  schedule,
  setSelectedSchedule,
  selectedSchedule,
  onClick,
}) => {
  return (
    <ScheduleCardStyle
      isSelected={selectedSchedule?.id === schedule?.id}
      // onClick={() => setSelectedSchedule(schedule)}
      onClick={onClick}
      className="py-6 pl-6 pr-10 flex items-center justify-between cursor-pointer"
    >
      <div>
        <P color="#22202D" fontFamily="semi" className="mb-0 capitalize">
          {schedule?.title} - {_case?.referral?.user?.firstName}
        </P>
        <div className="flex items-center">
          <P color="#7D7B96" fontSize="14px" smallSize="14px" className="capitalize">
            {schedule?.location}
          </P>

          <P
            color="#7D7B96"
            fontSize="12px"
            smallSize="12px"
            className="capitalize ml-1"
          >
            &#9679; {schedule?.status}
          </P>
        </div>
      </div>
      <Icon.ChevronRight color="#7D7B96" size={18} />
    </ScheduleCardStyle>
  );
};
